import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LounasPage from "./pages/LounasPage";
import KahvilaPage from "./pages/KahvilaPage";
import PitopalveluPage from "./pages/PitopalveluPage";
import TarinaPage from "./pages/TarinaPage";
import YhteystiedotPage from "./pages/YhteystiedotPage";
import BuffetkoneePage from "./pages/BuffetkoneePage";
import PikkujoulutPage from "./pages/PikkujoulutPage";
import { Toaster } from "./components/ui/sonner";
import { SummerBreakBanner } from "./components/SummerBreakNotice";

// Scroll to top when route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SummerBreakBanner />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/lounas" element={<LounasPage />} />
            <Route path="/kahvila" element={<KahvilaPage />} />
            <Route path="/pitopalvelu" element={<PitopalveluPage />} />
            <Route path="/buffetkone" element={<BuffetkoneePage />} />
            <Route path="/pikkujoulut" element={<PikkujoulutPage />} />
            <Route path="/tarina" element={<TarinaPage />} />
            <Route path="/yhteystiedot" element={<YhteystiedotPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
